<script>
    /*
    	TCareLoginPopup.svelte

        Receives the following  as a prop:

        const popupFunctions = {
            onSignUpClick: onSignUpClick,
            onLoginClick: onLoginClick,
            onForgotPasswordClick: onForgotPasswordClick,
            onEmailHelpClick: onEmailHelpClick,
            onPasswordHelpClick: onPasswordHelpClick
        }

    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiHelpCircleOutline } from '@mdi/js';

    export let isShowing;
    export let popupFunctions;

    onMount(() => {
    })

</script>

<style>
    .login-popup-bg {
        z-index: 999;             /* should be above EVERYTHING even header, footer */
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
    }

    .login-popup-wrapper {
        position: relative;
        width: 520px;
        margin: auto;
        margin-top: 30vh;
        background-color: none;     /* transparent */
        /* border: 1px solid red; */
    }

    .login-popup-window {
        width: 100%;
        border-radius: 40px;
        background-color: white;
        overflow: hidden;
    }

    .login-popup-window .logo {
        padding: 10px 30px;
        /* border: 1px solid red; */
    }

    .login-popup-window .logo img {
        height: 30px;
    }

    .login-popup-window .content {
        width: 440px;
        margin-left: 40px;
        height: 50%;
        /* border: 1px solid green; */
    }

    .content .please-provide {
        margin: 10px 0px 20px 0px;
        color: var(--tcui-primary);
        font-weight: 600;
        font-size: 17px;
        line-height: 19px;        
    }

    .content .input-row {
        width: 100%;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .content .input-row input {
        width: 86%;     /* plus 2% padding */
        padding: 2%;
        font-size: 14px;
        border: 1px solid #BFA1BF;
        border-radius: 5px;
    }

    :global(.content .input-row svg) {
        width: 28px;
        height: 28px;
        margin-left: 10px;
        fill: #BFA1BF;
        stroke-width: 1px;
        outline: none;
    }

    :global(.content .input-row svg:hover) {
        fill: var(--tcui-secondary);
    }

    .content .forgot-pw {
        color: var(--tcui-light-purple);
        font-size: 10px;
        text-decoration: underline;
        text-align: right;
        margin-top: 5px;
        margin-right: 10%;
        cursor: pointer;
    }

    .content .forgot-pw:hover {
        color: var(--tcui-secondary);
    }

    .login-popup-window .buttons {
        height: 30%;
        /* border: 1px solid blue; */
    }

    .buttons .no-account {
        color: var(--tcui-dark-purple);
        font-size: 11px;
        margin-top: 20px;
        margin-left: 130px;
    }

    .buttons .buttons-row {
        margin: 5px 0px 30px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .buttons .buttons-row button {
        width: 130px;
        height: 35px;
        border: none;
        border-radius: 20px;
    }

    .buttons .buttons-row .spacer {
        width: 10px;
    }

    .login-popup-wrapper img {
        margin-top: 15px;
    }

    .buttons .sign-up {
        color: var(--tcui-white);
        background-color: var(--tcui-dark-purple);
    }

    .buttons .sign-up:hover {
        background-color: var(--tcui-aqua);
    }

    .buttons .log-in {
        color: var(--tcui-white);
        background-color: var(--tcui-secondary);
    }

    .buttons .log-in:hover {
        background-color: var(--tcui-aqua);
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- TRANSITIONS NOT WORKING ON POPUP!!! -->

{#if isShowing}
    <div class="login-popup-bg" >
        <div class="login-popup-wrapper" transion:fade >
            <div class="login-popup-window" >
                <div class="logo">
                    <img src='/img/logo_wide.png' alt='Logo' draggable="false">
                </div>
                <div class="content">
                    <div class="please-provide">Please provide the following details:</div>
                    <div class="input-row">
                        <input placeholder="Enter your email address" />
                        <!--
                        <Icon component={Svg} viewBox="0 0 24 24" on:click={popupFunctions.onEmailHelpClick} >
                            <path d={mdiHelpCircleOutline} />
                        </Icon>
                        -->
                    </div>
                    <div class="input-row">
                        <input placeholder="Enter your password" />           
                        <!--
                        <Icon component={Svg} viewBox="0 0 24 24" on:click={popupFunctions.onPasswordHelpClick} >
                            <path d={mdiHelpCircleOutline} />
                        </Icon>
                        -->
                    </div>
                    <div class="forgot-pw" on:click={popupFunctions.onForgotPasswordClick}>Forgot your password?</div>
                </div>
                <div class="buttons">
                    <div class="no-account">Don’t have an account?</div>
                    <div class="buttons-row">
                        <button class="sign-up" on:click={popupFunctions.onSignUpClick}>Sign Up</button>
                        <div class="spacer"></div>
                        <button class="log-in" on:click={popupFunctions.onLoginClick}>Login</button>
                    </div>
                </div>
            </div>
            <img src='/img/Login_Design.svg' alt='Design' draggable="false">
        </div>
    </div>
{/if}
